export default __webpack_public_path__ + "static/char-11-055f9eb5677654d43104d26300e89ead.gif";